export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

type NonNullableProperties<T> = {
  [K in keyof T]: NonNullable<T[K]>;
};

export function removeNullProperties<T extends object>(
  obj: T
): Partial<NonNullableProperties<T>> {
  const result = {} as Partial<NonNullableProperties<T>>;

  Object.keys(obj).forEach((key) => {
    if (obj[key as keyof T] !== null) {
      (result as T)[key as keyof T] = obj[key as keyof T];
    }
  });

  return result;
}

export function assertNever(x: never): never {
  throw new Error("unreachable:" + x);
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/** 配列を size 件ずつに分割する。末尾は size 未満になりうる。 */
export function chunk<T>(items: readonly T[], size: number): T[][] {
  return Array.from({ length: Math.ceil(items.length / size) }, (_, index) =>
    items.slice(index * size, (index + 1) * size)
  );
}
